export default __webpack_public_path__ + "static/media/email-coupon-autolink-example.bc9af2c2.png";